import { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Card = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    className,
    expanded,
    initiallyExpanded,
    onExpandChange,
    title,
    style,
    applyBorder,
    children
  } = props;
  const controlled = onExpandChange ? true : false;
  const [uncontrolledState, setUncontrolledState] = useState(initiallyExpanded);
  const cardClass = cn('bg-white', {
    'border': applyBorder
  }, className);
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: cardClass,
    style: style,
    ref: ref,
    children: [title && /*#__PURE__*/_jsx("h2", {
      className: "border-b border-solid border-med-pale-blue p-3",
      children: title
    }), filterChildren(children, {
      expanded: controlled ? expanded : uncontrolledState,
      onExpandChange: () => controlled ? onExpandChange() : setUncontrolledState(!uncontrolledState)
    })]
  });
});
Card.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Whether this card is expanded. */
  expanded: PropTypes.bool,
  /** Only applicable to uncontrolled Card.  Whether this card is initially expanded. */
  initiallyExpanded: PropTypes.bool,
  /** Only applicable and REQUIRED for controlled Card.  Callback function fired when the expandable state of the card has changed.  */
  onExpandChange: PropTypes.func,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** If true, applies a border around the card */
  applyBorder: PropTypes.bool,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node
};
Card.displayName = 'Card';
export default Card;
//# sourceMappingURL=Card.js.map